// extracted by mini-css-extract-plugin
export var blockedMessage = "_89-3";
export var blockedOverlay = "_89-1";
export var fadeIn = "_89-2";
export var hereLink = "_89-0";
export var slideUp = "_89-4";